import LegalPageLayout from "@/components/landing/LegalPageLayout";

const faqCategories = [
  {
    title: "Getting Started",
    items: [
      {
        q: "How do I apply for a Trust Wallet Card?",
        a: "Click 'Apply Now' on our homepage, connect your Trust Wallet, and complete the identity verification (KYC) process. Most applications are approved within minutes."
      },
      {
        q: "What cryptocurrencies can I spend?",
        a: "You can spend Bitcoin (BTC), Ethereum (ETH), USDT, USDC, BNB, MATIC, TRX, and 50+ other supported tokens. The full list is available in the app."
      },
      {
        q: "Is there a minimum balance required?",
        a: "No minimum balance is required for the Standard card. The Silver tier requires $10,000+ and the Metal card requires $100,000+ USDT equivalent in your connected wallet."
      },
      {
        q: "Which countries are supported?",
        a: "Trust Wallet Card is available in 40+ countries across North America, Europe, and Asia-Pacific. Check the app for availability in your specific region."
      },
    ]
  },
  {
    title: "Card Management",
    items: [
      {
        q: "How do I activate my card?",
        a: "Physical cards are activated automatically upon first use at a POS terminal or ATM. Virtual cards are active immediately upon issuance and can be added to Apple Pay or Google Pay."
      },
      {
        q: "How do I freeze or lock my card?",
        a: "Open the Trust Wallet app, navigate to the Card section, and toggle the freeze switch. Your card will be instantly locked and no transactions will be processed until you unfreeze it."
      },
      {
        q: "What are the spending limits?",
        a: "Standard: $10,000/day, Silver: $25,000/day, Metal: $50,000/day. Monthly limits are 4x the daily limit. ATM withdrawals are limited to $5,000/day."
      },
      {
        q: "How do I report a lost or stolen card?",
        a: "Immediately freeze your card in the app and contact our 24/7 support team. We'll issue a replacement card — free for Metal tier, $10 for Standard/Silver."
      },
    ]
  },
  {
    title: "Rewards & Benefits",
    items: [
      {
        q: "How does the crypto rewards program work?",
        a: "Every eligible purchase earns crypto rewards: 3% on dining & travel, 2% on online shopping, 1% on everything else. Rewards are deposited into your connected wallet within 24 hours."
      },
      {
        q: "Can I choose which cryptocurrency I earn?",
        a: "Yes! You can select your preferred reward currency from any supported token. Change your reward preference at any time in the app settings."
      },
      {
        q: "What is the 2x Rewards Multiplier for Metal cardholders?",
        a: "Metal card holders earn double rewards on all purchases — up to 6% on dining & travel, 4% on online shopping, and 2% on everything else."
      },
    ]
  },
  {
    title: "Security",
    items: [
      {
        q: "Is my crypto safe?",
        a: "Your crypto remains in your own Trust Wallet at all times. We only access funds at the moment of transaction, converting exactly the amount needed. We never hold custody of your assets."
      },
      {
        q: "What security measures are in place?",
        a: "256-bit encryption, biometric authentication, real-time fraud monitoring, PCI DSS Level 1 compliance, SOC 2 Type II certification, and regular third-party security audits by CertiK."
      },
    ]
  },
];

const HelpCenter = () => (
  <LegalPageLayout title="Help Center" lastUpdated="January 15, 2026">
    <p className="text-lg">
      Find answers to common questions about Trust Wallet Card. Can't find what you're looking for? Contact our support team through the Trust Wallet app.
    </p>

    {faqCategories.map((category) => (
      <section key={category.title}>
        <h2>{category.title}</h2>
        {category.items.map((item) => (
          <div key={item.q} className="mt-6 rounded-2xl border border-border/60 bg-card/80 p-6">
            <h3 className="!mt-0">{item.q}</h3>
            <p>{item.a}</p>
          </div>
        ))}
      </section>
    ))}
  </LegalPageLayout>
);

export default HelpCenter;
